<template>
  <v-chip v-if="value" small @click="onClick">
    <span :class="{ 'showPointer': isEntityOrigin }">{{ text }}</span>
  </v-chip>
  <v-chip v-else small>
    <span>{{ $t('message.seo.metas.noOrigin')}}</span>
  </v-chip>
</template>

<script>
import { entityRouter } from '@/modules/entity/router';

const ORIGIN_HARDCODED = 'hardcoded';
const ORIGIN_ENTITY = 'entity';

export default {
  name: 'nx-seo-origin-chip',
  props: {
    value: {
      type: Object,
    },
  },
  computed: {
    isEntityOrigin() {
      return this.value && this.value.from === ORIGIN_ENTITY;
    },
    text() {
      if (!this.value) {
        return null;
      }

      if (this.value.from === ORIGIN_HARDCODED) {
        return this.$t('message.seo.origin.from.hardcoded');
      }

      return this.$t('message.seo.origin.from.entity', { name: this.value.name });
    },
  },
  methods: {
    onClick() {
      if (!this.isEntityOrigin) {
        return;
      }
      entityRouter.toEditor(this.value.entity, { id: this.value.entityId });
    },
  },
};
</script>

<style lang="stylus" scoped>
.showPointer {
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}
</style>
